module.exports = __webpack_public_path__ + "static/media/security-check_5.35f65cdc.png";